<template>
  <div
    class="placeholder"
    :class="{ 'placeholder-message-visible': displayMessage }">
    The request could not be processed.<br>
    Please try again or refresh the page (F5).

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ItemViewPlaceholder',
  components: {
  },
  data() {
    return {
      displayMessage: false,
    };
  },
  computed: {
    ...mapState({
      selectedCollection: state => state.collections.selectedCollection,
    }),
    ...mapGetters({
      getCardRef: 'cards/getCardRef',
    }),
    cardId() {
      return Number(this.$route.params.cardId) || null;
    },
  },
  methods: {
    ...mapMutations({
      ToggleDisplayItemView: 'appState/ToggleDisplayItemView',
    }),
    ...mapActions({
      openInWebViewer: 'files/openInWebViewer',
    }),
  },
  watch: {
    cardId() {
      if (this.$route.name === 'WebViewer') {
        const { cardId, selectedCollection: relatedCollectionId } = this;
        const card = this.getCardRef({ cardId, relatedCollectionId });
        this.openInWebViewer(card);
      }
    },
  },
  created() {
    setTimeout(() => {
      this.displayMessage = true;
    }, 1000);
    this.ToggleDisplayItemView(true);

    const { cardId, selectedCollection: relatedCollectionId } = this;
    const card = this.getCardRef({ cardId, relatedCollectionId });
    this.openInWebViewer(card);
  },
  beforeDestroy() {
    this.displayMessage = false;
    this.ToggleDisplayItemView(false);
  },
};
</script>

<style lang="scss" scoped>
.placeholder {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 15vh;
  opacity: 0;
  transition: opacity 0.2s;
}
.placeholder-message-visible {
  opacity: 1;
}
</style>
